import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { ContentProvider } from "../lib/content";
import WhatsAppFloat from "./WhatsAppFloat";

export default function FocusShell({ title, description, testid, children }) {
  useEffect(() => {
    document.title = title;
    let el = document.head.querySelector('meta[name="description"]');
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", "description");
      document.head.appendChild(el);
    }
    el.setAttribute("content", description);
    let canon = document.head.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.setAttribute("rel", "canonical");
      document.head.appendChild(canon);
    }
    canon.setAttribute("href", window.location.origin + window.location.pathname);
    window.scrollTo(0, 0);
  }, [title, description]);

  return (
    <ContentProvider>
      <main data-testid={testid} className="min-h-screen bg-sand-bg flex flex-col">
      <header className="border-b border-sand-border bg-white/85 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 h-[72px] flex items-center justify-between">
          <Link to="/" data-testid="focus-brand-logo" aria-label="Reef Deco — home" className="flex items-center">
            <img src="/logo.png" alt="Reef Deco — Curtains | Blinds | Interiors" className="h-9 sm:h-10 w-auto" />
          </Link>
          <Link
            to="/"
            data-testid="focus-back-home-link"
            className="flex items-center gap-2 font-mono text-[11px] tracking-[0.15em] uppercase text-slate-600 hover:text-reef transition-colors duration-200"
          >
            <ArrowLeft className="w-3.5 h-3.5" />
            Back to website
          </Link>
        </div>
      </header>

      <div className="flex-1">{children}</div>

      <footer className="border-t border-sand-border py-8">
        <p className="text-center font-mono text-[10px] tracking-[0.2em] uppercase text-slate-500">
          © {new Date().getFullYear()} Reef Deco — Curtains | Blinds | Interiors · Dubai
        </p>
      </footer>
      <WhatsAppFloat />
      </main>
    </ContentProvider>
  );
}
